import {
  PlaybackContextType,
  PlaybackProviderProps,
} from './context/PlaybackContext';
import { usePlayback } from './context/PlaybackContext';
import { PlayerProvider } from './context/PlayerContext';
import Player, { PlayerProps } from './Player';
import PlayerUi, { PlayerUiProps } from './PlayerUi';
import { PlaybackState } from './types';

// the default PlayerUi already wrapped with PlayerContext
export default Player;
export {
  // used to wrap the PlayerUi.  PlayerProvider + PlayerUi can be used instead of
  // Player when other components also need access to the PlayerContext
  PlayerProvider,
  // raw PlayerUi without the PlayerProvider
  PlayerUi,
  usePlayback,
};
export type {
  PlaybackContextType,
  PlaybackProviderProps,
  PlayerProps,
  PlayerUiProps,
  PlaybackState,
};
